"use client";

import React from "react";
import { BoxAlignItems, InputSearch, FilterDate } from "@/components";
import { DictionaryProps } from "@/types";

interface SubscriberFiltersProps extends DictionaryProps {
  params?: any;
  updateParams: (newParams: any) => void;
  dateRange?: { start: Date; end: Date };
  handleDateChange?: (range: { start: Date; end: Date }) => void;
  handleSubmitFilter?: () => void;
}

const SubscriberFilters: React.FC<SubscriberFiltersProps> = ({
  dict,
  params,
  updateParams,
  dateRange,
  handleDateChange,
  handleSubmitFilter,
}) => {
  return (
    <BoxAlignItems justify="center" className="overflow-visible">
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4 w-full sm:w-auto overflow-visible">
        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-4 flex-1 sm:flex-initial overflow-visible">
          <label className="text-sm font-medium text-gray-700 dark:text-gray-300 whitespace-nowrap">
            {dict.Status}
          </label>
          <select
            value={params?.status || ""}
            onChange={(e) =>
              updateParams({
                status: e.target.value,
                current_page: 1,
              })
            }
            className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 w-full sm:w-48 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
          >
            <option value="">{dict.All}</option>
            <option value="Ativo">
              {dict["Active Subscribers"] || "Ativos"}
            </option>
            <option value="Pausada">
              {dict["Paused Subscribers"] || "Pausada"}
            </option>
            <option value="Expirado">
              {dict["Expired Subscribers"] || "Vencidos"}
            </option>
            <option value="Cancelado">
              {dict["Canceled Subscribers"] || "Cancelados"}
            </option>
            <option value="Pendente">
              {dict["Pending Subscribers"] || "Pendentes"}
            </option>
          </select>
        </div>
        <div className="flex-1 sm:flex-initial min-w-0 overflow-visible">
          <InputSearch
            className="w-full sm:w-56"
            icon="search"
            placeholder={dict.Search}
            name="search"
            value={params?.search || ""}
            onChange={(e) =>
              updateParams({ search: e.target.value, current_page: 1 })
            }
          />
        </div>
        {dateRange && handleDateChange && (
          <div className="flex-shrink-0 overflow-visible">
            <FilterDate
              value={dateRange}
              onChange={handleDateChange}
              onSubmitFilter={handleSubmitFilter}
            />
          </div>
        )}
      </div>
    </BoxAlignItems>
  );
};

export default SubscriberFilters;
